import styled from 'styled-components';
import { SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT } from '@oneaudi/unified-web-common';
import { CARGROUP_HOVER_SCALE } from '../../constants';
import { Layout, Tag, Text } from '@oneaudi/unified-web-components';

const ARROW_BUTTON_WIDTH = '46px';
export const Container = styled.div`
  display: block;
  text-align: center;
  padding-bottom: 0;
  @media (min-width: ${(props) => props.theme.breakpoints.md}px) {
    margin-inline: ${process.env.IS_LEGACY
      ? `calc(var(--page-margin) - ${ARROW_BUTTON_WIDTH})`
      : `0`};
    ${process.env.IS_LEGACY &&
    `
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;

      > *:first-child {
        order: 2;
      }
      > *:nth-child(2) {
        order: 1;
      }
      > *:nth-child(3) {
        order: 3;
      }
    `}
  }
`;

export const ResultAndNavigationWrapper = styled(Layout)`
  margin: 0 var(--page-margin) ${({ theme }) => theme.spacing.fixed100};

  @media (min-width: ${(props) => props.theme.breakpoints.md}px) {
    margin: 0 var(--page-margin) ${({ theme }) => theme.spacing.fixed100} var(--page-margin);
  }
`;

export const SliderContainer = styled.ul`
  display: flex;
  flex-grow: 1;
  gap: ${({ theme }) => theme.spacing.fixed100};

  padding: 0;
  margin: 0;
  overflow-x: auto;
  scrollbar-width: 0;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
  /* hide scrollbar firefox */
  scrollbar-width: none;
`;

export const ArrowWrapper = styled.div`
  display: flex;
`;

export const CardWrapper = styled.li`
  scroll-snap-align: start;
  overflow: hidden;
  list-style: none;

  min-width: 220px;
  width: 220px;
  &:first-child {
    padding-inline-start: var(--page-margin);
    @media (min-width: ${(props) => props.theme.breakpoints.lg}px) {
      padding-inline-start: ${process.env.IS_LEGACY ? 0 : 'var(--page-margin)'};
    }
  }
  &:last-child {
    padding-inline-end: var(--page-margin);

    @media (min-width: ${(props) => props.theme.breakpoints.lg}px) {
      padding-inline-end: ${process.env.IS_LEGACY ? 0 : 'var(--page-margin)'};
    }
  }
`;

export const StyledSliderItem = styled.span`
  cursor: pointer;
  text-align: left;
  display: block;
  ${process.env.IS_LEGACY &&
  `
      height: 151px;
     padding: var(--spacing-relative-md);
      &.selected {
      background-color: ${SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT};
      }
  `}

  &:hover img {
    transform: scale(${CARGROUP_HOVER_SCALE});
    transition: transform 0.4s ease;
  }
`;

export const StyledButton = styled('button').withConfig({
  shouldForwardProp: (prop) => !['onPress'].includes(prop),
})`
  background-color: transparent;
  border: none;
  display: flex;
  cursor: pointer;
  width: 100%;
  justify-content: space-between;
`;

export const StyledImage = styled('img')`
  padding-bottom: ${({ theme }) => theme.spacing.fixed150};
  transition: transform 0.5s;
  object-fit: cover;
`;

export const StyledHeadingSection = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.fixed100};
`;

export const StyledTag = styled(Tag)`
  background: transparent;
  border: solid ${({ theme }) => theme.borderWidth} ${({ theme }) => theme.colors.tagBorderColor};
`;

export const StyledText = styled(Text)`
  width: 100%;
`;
